import http from '@/utils/request'

export async function view(param, callId = null, callArgs = {}) {
  let url = '/org/' + param.id
  if (param && param.query) { url += param.query }

  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

export async function update(param, callId = null, callArgs = {}) {
  let url = '/org/' + param.id
  if (param && param.query) { url += param.query }

  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'PUT',
    data: param
  })
}

export async function me(param, callId = null, callArgs = {}) { // /org/me?expand=orgUser,orgUser.user
  let url = '/org/me'
  if (param && param.query) { url += param.query }

  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

export async function member(param, callId = null, callArgs = {}) { // org/:id/?expand=formUser,formUser.user
  let url = `/org/${param.id}/member`
  if (param.query) { url += param.query }

  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

// export async function order(param, callId = null, callArgs = {}) { // org/:id/?expand=formUser,formUser.user
//   let url = `/org/${param.id}/order`
//   if (param.query) { url += param.query }

//   return await http.request({
//     callId: callId,
//     callArgs: callArgs,
//     url: url,
//     method: 'GET'
//   })
// }

// org user

export async function listOrgUser(param, callId = null, callArgs = {}) {
  let url = `/org/list_org_user`
  if (param.query) {
    url += param.query
  }
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

// 参数：
// {
//   "org_id": 1160827977498886144,
//   "account": 1143634047980273664 / 手机号
// }
export async function createOrgUser(data, callId = null, callArgs = {}) {
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: '/org/create_org_user',
    method: 'post',
    data
  })
}

export async function delOrgUser(param, callId = null, callArgs = {}) {
  let url = `/org/del_org_user`
  if (param.query) {
    url += param.query
  }

  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'post'
  })
}

export async function updateOrgUser(data, callId = null, callArgs = {}) {
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: `/org/update_org_user`,
    method: 'post',
    data
  })
}

export async function fetchSub(param, callId = null, callArgs = {}) {
  let url = `/org/fetch_sub`
  if (param.query) {
    url += param.query
  }
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

export async function fetchWxopen3AuthUrl(param, callId = null, callArgs = {}) {
  let url = `/org/fetch_wxopen3_auth_url`
  if (param.query) {
    url += param.query
  }
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

export async function fetchPaySetting(param, callId = null, callArgs = {}) {
  let url = `/org/fetch_pay_setting`
  if (param.query) {
    url += param.query
  }
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

export async function savePaySetting(param, callId = null, callArgs = {}) {
  let url = `/org/save_pay_setting`
  if (param.query) {
    url += param.query
  }

  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'post',
    data: param.data
  })
}

export async function delPaySetting(param, callId = null, callArgs = {}) {
  let url = `/org/del_pay_setting`
  if (param.query) {
    url += param.query
  }

  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'post'
  })
}
